<template>
  <div>
    <div class="vx-col w-full mb-base">
      <vs-card title="Add New Customer" class="p-4 mb-6">
        <div slot="header" class="flex flex-wrap items-center justify-between">
           <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <h4>Adjust Inventory</h4>
          </div>
            <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
            <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm" :disabled="isForm == true ? false : true">Upload</vs-button>
            <vs-dropdown>
                <vs-button class="btn-drop" icon="expand_more">Template</vs-button>
                <vs-dropdown-menu>
                    <vs-dropdown-item @click="getTemplate({endpoint: 'inventories/adjust/in', name: 'adjust_in'})">Adjust In</vs-dropdown-item>
                    <vs-dropdown-item @click="getTemplate({endpoint: 'inventories/adjust/out', name: 'adjust_out'})">Adjust Out</vs-dropdown-item>
                    <vs-dropdown-item @click="getTemplate({endpoint: 'inventories/adjust/expdate', name: 'adjust_expireddate'})">Adjust Expired Date</vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>
            </div>
        </div>
        <div class="vx-row mt-6">
          <div class="vx-col md:w-1/4 w-full">

              <label class="vs-input--label">Type</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="adjustType"
                    width="100%"
                    autocomplete
                >
                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in optionAdjust" />
                </vs-select>

            <label class="vs-input--label">File</label>
                <vs-upload
                    :showUploadButton="false"
                    :text="fileName"
                    @change="getSelectedFile"
                    ref="file_upload" />

          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      fileName: "Select file (.xslx, .xls)", 
      isLoading: false,
      isForm: false,
      file:null,
      adjustType:"",
      optionAdjust: [
        {text:'OUT',value:'AOUT'},
        {text:'IN',value:'AIN'},
        {text:'EXPD',value:'EXPD'},
      ]
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    getSelectedFile() {
        const files = this.$refs.file_upload.filesx;

        if(files.length > 1) {
            files.splice(0, 1);
        }

        const file = files[0];

        if(file) {
            const filetype = file.type;
            if(filetype !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && filetype !== 'application/vnd.ms-excel') {
                files.splice(0, 1);
                this.uploadData.file = null;

                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'Invalid file format',
                })
            }
            else {
                this.file = file;
                this.fileName = file.name;
                this.isForm = true
            }
        }
    },
    submitForm() {
      this.isLoading = true;
      
       let formData = new FormData();
        formData.append("file", this.file);

        let url = '';

        if(this.adjustType =='AOUT'){
            url = 'inventories/adjust/out';
        }else if(this.adjustType =='AIN'){
            url = 'inventories/adjust/in';
        }else{
          url = 'inventories/adjust/expdate';
        }

        this.$http.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
        .then(resp => {
            console.log(resp.data.message);
            this.isLoading = false;
            const message = resp.data.message
            this.$vs.notify({
                color: "success",
                title: "Success",
                text: message
            });

            setTimeout(() => {
                window.location.reload()
            }, 200);
            
        })
        .catch(error => this.handleError(error))

    },
    checkForm(){
      if(this.current_password.length > 2){
        if(this.new_password.length > 2){
          if(this.new_password == this.re_password){
            this.isForm = true
          }
        }
      }
    },
    back() {
      if (
        this.current_password != "" ||
        this.new_password != "" ||
        this.re_password != ""
      ) {
        this.$vs.dialog({
          color: "warning",
          title: "Leave Page",
          text: "Changes you made may not be saved?",
          acceptText: "Leave Page",
          accept: () => this.$router.go(-1)
        });
      } else {
        this.$router.go(-1);
      }
    },
  },
  mounted() {
  }
};
</script>